import React from 'react';
import { styled } from 'linaria/react';
import { useQuery } from 'react-apollo';
import techQuery from './TechQuery.gql';
import { ContentRender } from '../../ContentRender/ContentRender';

const TechWrapper = styled.div`
  > li {
    margin: 5px 0;
  }
`;

const SingleTech = styled.div`
  margin-bottom: 6%;
  > .title {
    text-align: center;
    margin-bottom: 3%;
  }
`;

const Tech = ({ baseUrl, item }) => {
  const url = '/' + baseUrl + '/' + item + '/';
  const result = useQuery(techQuery, {
    variables: { path: url }
  });
  if (!result.data) return null;
  const category = result.data.route?.object;
  return (
    <SingleTech>
      <h2 className="title">{category.name}</h2>
      <ContentRender data={category.data} />
    </SingleTech>
  );
};

export const Technologies = ({ data }) => {
  if (!data.listValues || data.listValues.length === 0) return null;
  const baseUrl = data.title.toLowerCase();
  return (
    <TechWrapper>
      {data.listValues.map((item, index) => {
        return <Tech key={index} baseUrl={baseUrl} item={item} />;
      })}
    </TechWrapper>
  );
};
